import gql from "graphql-tag";

export const CHANGE_STATE_BENEF = gql`
  mutation ChangeEstadoSolicitud(
    $id_estado: String!
    $id_solicitud: String!
    $id_usuario: String!
  ) {
    ChangeEstadoSolicitud(
      id_estado: $id_estado
      id_solicitud: $id_solicitud
      id_usuario: $id_usuario
    ) {
      id_solicitud
      codigo_solicitud
      nombre
      descripcion
      fecha_creacion
      estado_solicitud {
        id_estado_solicitud
        nombre
        descripcion
        color
      }
      detalle_solicitud {
        id_solicitud_detalle
        nombre
        descripcion
        cantidad_solicitada
        cantidad_modificada
        cantidad_entregada
        inventario {
          id_inventario
          codigo_inventario
          nombre
          descripcion
          cantidad_inicial
          cantidad_actual
          con_limite
          limite_cantidad
          con_detalle
        }
        inventario_detalle {
          id_detalle
          nombre_detalle
          descripcion
          tipo_detalle
          editable
          id_formulario_fk
          codigo_detalle
        }
        valores_formulario {
          id_valor
          valor
          formulario_selector {
            id_formulario
            nombre
            tipo_dato
            con_valor_predeterminado
            is_selector
            nombre_header
          }
        }
      }
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        imagen_perfil
        fecha_ingreso
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      tipo_solicitud {
        id_tipo
        nombre_solicitud
        descripcion
        url_imagen
        datos_formulario {
          id_formulario
          nombre
          tipo_dato
          con_valor_predeterminado
          informacion_usuario
          is_selector
          is_admin

          datos_selector_empresa {
            id_dato_selector
            nombre
            descripcion
            id_formulario_dato_fk
          }
          datos_selector_inventario {
            id_detalle
            nombre_detalle
            descripcion
            tipo_detalle
            editable
            id_formulario_fk
            codigo_detalle
          }
          datos_selector_producto {
            id_inventario
            codigo_inventario
            nombre
            descripcion
            cantidad_inicial
            cantidad_actual
            con_limite
            limite_cantidad
            con_detalle
            detalles_inventario {
              id_detalle
              nombre_detalle
              descripcion
              tipo_detalle
              editable
              id_formulario_fk
              codigo_detalle
            }
          }
        }
      }
    }
  }
`;

// Settings beneficios
// CreateOrUpdateServicioPeriodo, CreateOrUpdateServicioCondicion
/*
 [RangosPeriodos]
  Input Fields
    fin: String
    inicio: String
[RangosTiempos]
  Input Fields
    desde:Int
    hasta:Int
*/
export const [CU_SERVICIO_PERIODO, CU_SERVICIO_CONDICION] = [gql`
mutation CreateOrUpdateServicioPeriodo($idSolicitud: Int!, $idTipo: Int!, $rangos: [RangosPeriodos], $diasSemana: [Int]) {
  CreateOrUpdateServicioPeriodo(id_solicitud: $idSolicitud, id_tipo: $idTipo, rangos: $rangos, dias_semana: $diasSemana) {
    id_solicitud_empresa
  }
}`, gql`mutation CreateOrUpdateServicioCondicion($idSolicitud: Int!, $idTipo: Int!, $cArea: [Int], $cGenero: [String], $cIngreso: [RangosTiempos], $cNacimiento: [RangosTiempos]) {
  CreateOrUpdateServicioCondicion(id_solicitud: $idSolicitud, id_tipo: $idTipo, c_area: $cArea, c_genero: $cGenero, c_ingreso: $cIngreso, c_nacimiento: $cNacimiento) {
    id_solicitud_empresa
    id_tipo_solicitud_fk
  }
}
`];